<span class="smart-title">{{ name | translate }}</span>
<span class="smart-subtitle">{{ description | translate }}</span>
<ng-content></ng-content>
<span *ngIf="information">{{ information | translate }}</span>
